__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-iam-messaging/v3_8_10/";